import { render, staticRenderFns } from "./InventorySnapshot.vue?vue&type=template&id=51297558"
import script from "./InventorySnapshot.vue?vue&type=script&lang=js"
export * from "./InventorySnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports